import { toast } from 'react-toastify'
import type { NotificationProvider, OpenNotificationParams } from '@refinedev/core'

type ToastType = 'success' | 'error' | 'info' | 'warning' | 'default'

const getToastType = (type: string): ToastType => {
  switch (type) {
    case 'success':
      return 'success'
    case 'error':
      return 'error'
    default:
      return 'default'
  }
}

export const customNotificationProvider = (): NotificationProvider => {
  return {
    open: ({ message, description, type }: OpenNotificationParams): void => {
      const currentPath = window.location.pathname
      const isAuthPage =
        currentPath === '/login' ||
        currentPath === '/register' ||
        currentPath === '/activate' ||
        currentPath === '/forgot-password' ||
        currentPath === '/reset-password' ||
        currentPath === '/share-login'

      if (!isAuthPage) {
        return
      }

      const toastType = getToastType(type)
      const toastMessage = description || message

      toast(toastMessage, {
        type: toastType,
        position: 'top-center',
        autoClose: type === 'error' ? 8000 : 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          whiteSpace: 'pre-line',
          maxWidth: '400px',
          fontSize: '14px',
        },
      })
    },
    close: (key: string) => {
      toast.dismiss(key)
    },
  }
}
